<template>
  <section>
    <div class="portada">
      <h1 class="title">{{ `Bienvenid@ ${this.nombres}` }}</h1>
      <p>{{ $t("inicio.detalle") }}</p>
      <div class="btn-opciones">
        <router-link class="btn btn-primary btn-large" to="/solicitud"
          ><i class="icon-document"></i>
          {{ $t("inicio.btnSolicitar") }}</router-link
        >
        <router-link class="btn btn-primary btn-large" to="/seguimiento">
          <i class="icon-search"></i>
          {{ $t("inicio.btnSeguimiento") }}</router-link
        >
        <router-link class="btn btn-primary btn-large" to="/verificar"
          ><i class="icon-clipboard"></i>
          {{ $t("inicio.btnVerificar") }}</router-link
        >
        <router-link class="btn btn-primary btn-large" to="/"
          ><i class="lnr-exit"></i>
          {{ $t("inicio.btnCerrarSesion") }}</router-link
        >
      </div>
    </div>
  </section>
</template>

<script>
export default {
  data () {
    return {
      nombres: "nombre dumy"
    };
  },
  mounted () {
    this.$serviceoidc.getProfile().then(response => {
      if (response) {
        this.nombres = `${response.profile.nombre.nombres} ${response.profile.nombre.primer_apellido} ${response.profile.nombre.segundo_apellido}`;
      }
    });
  }
};
</script>

<style lang="scss">
.portada {
  max-width: 600px;
  margin: 5px auto 0;
  text-align: center;

  p {
    font-size: 1.3rem;
    line-height: 1.8rem;
    font-weight: 400;
    color: #707070;
  }

  .btn-opciones {
    margin-top: 50px;
  }

  .btn-large {
    margin: 0 auto 3px;
    width: 100%;
    max-width: 320px;
    display: block;
    padding: 0 15px;
    line-height: 60px;
    text-align: left;

    [class^="icon-"],
    [class*=" icon-"] {
      font-size: 2rem;
      float: left;
      line-height: 60px;
      margin-right: 10px;
      width: 32px;
    }
  }
}
@media (max-width: 768px) {
  .portada {
    margin-top: 0px;

    .btn-large {
      font-size: 0.9rem;
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/Home.vue